import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[appOrderedMasonryItem]',
  standalone: true,
})
export class OrderedMasonryItemDirective {
  public readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);
}
